__turbopack_context__.v({
  "chips": "CategoryChips-module-scss-module__2Avz9q__chips",
  "chips__heading": "CategoryChips-module-scss-module__2Avz9q__chips__heading",
  "chips__list": "CategoryChips-module-scss-module__2Avz9q__chips__list",
});
